import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMPLOYEE_COUNT);
var axios_instance_getAPI = get_axios_instance(api_variables.STD_GET_API);
var axios_instance_insertApi = get_axios_instance(api_variables.STD_INSERT_API);
var axios_instance_perqpopup = get_axios_instance(api_variables.POPUP_PERQ_PAYROLL);
var axios_instance_earningDeductionPopup = get_axios_instance(api_variables.POPUP_EARNING_DEDUCTION);
var axios_instance_lopRlopPopup= get_axios_instance(api_variables.POPUP_LOPRLOP_PAYROLL);
var axios_instance_NewJoinee_exitPopup= get_axios_instance(api_variables.POPUP_NEWJOINEE_EXIT);
var axios_instance_Salrev= get_axios_instance(api_variables.POPUP_SAL_REV);
var axios_instance_schEarningandTaxOutsidePopup = get_axios_instance(api_variables.POPUP_SCHEDULEDEARNING_TAXOUTSIDE);
var axios_instance_updateApi = get_axios_instance(api_variables.STD_UPDATE_API);
var axios_instance_LOPReport = get_axios_instance(api_variables.SERVICE_LOP_COUNT);
var axios_instance_InstallmentReport = get_axios_instance(api_variables.SERVICE_INSTALLMENT_COUNT);
var axios_instance_Perq = get_axios_instance(api_variables.SERVICE_PERQ);
var axios_instance_NewJoinersReport = get_axios_instance(api_variables.SERVICE_NEWJOINERS_COUNT);
var axios_instance_ExitReport = get_axios_instance(api_variables.SERVICE_EXIT_COUNT);
var axios_instance_TdsReport = get_axios_instance(api_variables.SERVICE_TDS_REPORT);
var axios_instance_insertApiPA = get_axios_instance(api_variables.PAYROLL_INSERT_API);
var axios_instance_getApiPA = get_axios_instance(api_variables.PAYROLL_GET_API);
var axios_instance_updateApiPA = get_axios_instance(api_variables.PAYROLL_UPDATE_API);
var axios_instance_insertApiPV = get_axios_instance(api_variables.PENDING_INSERT_API);
var axios_instance_getApiPV = get_axios_instance(api_variables.PENDING_GET_API);
var axios_instance_updateApiPV = get_axios_instance(api_variables.PENDING_UPDATE_API);
var axios_instance_getDate = get_axios_instance(api_variables.TO_GET_DATE);
var axios_instance_pan_fbp_itPopup = get_axios_instance(api_variables.PAN_FBP_ITDECL);
var axios_instance_Salrev_Excel= get_axios_instance(api_variables.SERVICE_SAL_REV);
var axios_instance_itProof_Excel= get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_PROOF_DETAILS);
var axios_instance_itDeclaration_Excel= get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_DECLARATION_DETAILS);

const _pk_name = "id";

const state = {
    data: [],
    entityWiseData: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEditMode: (state, payload) => {
        //console.log("payload---", payload.record);
        state.editMode = payload.editMode;
        state.record = payload.record;
    },
    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
        //console.log('fetched exits', state.exits)
    },

    addEmployee: (state, payload) => {
        //console.log('payload data from store', payload)
        state.exits = payload;
        //console.log('exit data', state.exits);
        //console.log('state data', state.data);
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
  async fetchAll({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async getValidatePayrollApi({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_getAPI.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async insertValidatePayrollApi({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_insertApi.post(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}`
      );
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async perquisitePopup({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_perqpopup.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async earningDeductionPopup({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_earningDeductionPopup.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async lopRlopPopup({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_lopRlopPopup.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async getPanFbpItApi({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_pan_fbp_itPopup.get(`/`, {
        params: {
          ...payload,
        },
      });
      commit("setFetching", false);
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  
  async newJoineeandExitPopup({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_NewJoinee_exitPopup.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async salaryRevPopup({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_Salrev.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async salaryRevReport({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_Salrev_Excel.get(`/`, {
        params: {
          ...payload,
        },
      });
      // let res = await axios_instance_Salrev.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async itProofReport({ commit }, payload) {
    try {
      commit("setFetching", true);
      console.log("axios_instance_itProof_Excel:",axios_instance_itProof_Excel);
      
      let res = await axios_instance_itProof_Excel.get(`/`, {
        params: {
          ...payload,
        },
      });
      // let res = await axios_instance_Salrev.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async itDeclaration({ commit }, payload) {
    try {
      commit("setFetching", true);
      console.log("axios_instance_itDeclaration_Excel:",axios_instance_itDeclaration_Excel);
      
      let res = await axios_instance_itDeclaration_Excel.get(`/`, {
        params: {
          ...payload,
        },
      });
      // let res = await axios_instance_Salrev.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async schEarningandTaxOutside({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_schEarningandTaxOutsidePopup.post(
        ``,
        payload
      );
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async updateValidatePayrollApi({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_updateApi.patch(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}&validate_input_id=${payload.validate_input_id}`
      );
      commit("setSaving", false);
      if (res.status == 200) {
        commit("addStatus", [res.data]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async fetchLOPReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_LOPReport.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async fetchInstallmentReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_InstallmentReport.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async fetchPerqReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_Perq.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async fetchNewJoinersReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_NewJoinersReport.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async fetchExitReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_ExitReport.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async fetchTdsReport({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_TdsReport.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async getPayrollApi({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_getApiPA.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async insertPayrollApi({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_insertApiPA.post(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}`
      );
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async updatePayrollApi({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_updateApiPA.patch(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}&payroll_action_id=${payload.payroll_action_id}`
      );
      commit("setSaving", false);
      if (res.status == 200) {
        commit("addStatus", [res.data]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async getPendingActionApi({ commit }, payload) {
    try {
      //console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_getApiPV.get(`/`, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async getDateApi({ commit }, payload) {
    try {
      console.log("In fetchAll start");
      commit("setFetching", true);
      let res = await axios_instance_getDate.get(``, {
        params: {
          ...payload,
        },
      });
      //console.log("In fetchAll ",  res);
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if (res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },
  async insertPendingActionApi({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_insertApiPV.post(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}`
      );
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async updatePendingActionApi({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_updateApiPV.patch(
        `?le_id=${payload.le_id}&month=${payload.month}&year=${payload.year}&pending_action_id=${payload.pending_action_id}&remarks=' '`
      );
      commit("setSaving", false);
      if (res.status == 200) {
        commit("addStatus", [res.data]);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
};

export default {
  namespaced: true,
  state, mutations, actions, getters
}
